module.exports = __webpack_public_path__ + "img/quienes3.f5fd85ea.jpg";